{
  "en": {
    "aiPersona": {
      "confirm": {
        "deleteConversation": {
          "text": "This action cannot be undone. The conversation will be permanently deleted with all messages.",
          "title": "Delete conversation?"
        }
      },
      "defaults": {
        "description": "Have a conversation with a chatbot which takes on the role of {name}"
      },
      "disclaimer": "This chat is an Artificial Intelligence (AI). The answers are made up. The AI is trying to act as if it were the corresponding person. Try it out, ask questions but stay critical and do fact checks if necessary. Have fun!",
      "emptyState": {
        "title": "Which role should your chatbot play?",
        "description": "Choose a character: Enter the name of a historical or fictional figure and kick off the conversation.",
        "hint": "<strong>Don't forget your own intelligence:</strong> AI may seem human, but it's just a machine. Stay sharp and engage your own critical thinking.",
        "createButton": "Create new character"
      },
      "deprecationAlert": {
        "title": "Attention: this area is currently being restructured!",
        "description": "To avoid misunderstandings when using AI, there are no more pre-made roles here. However, you can still create chatbots with your own roles.",
        "hint": "Tip: In our AI Assistants Catalog you will find a large selection of curated AI assistants and ready-made role chatbots.",
        "catalogLink": "Go to AI Assistants Catalog"
      },
      "historyAlert": {
        "title": "Attention: this area is moving soon!",
        "description": "In the future, you will find all past conversations exclusively in the AI Chat and can create new chatbots there.",
        "chatLink": "Go to AI Chat"
      },
      "flash": {
        "nameNotPermitted": "This character cannot be created."
      },
      "labels": {
        "name": "Name of the character"
      },
      "links": {
        "myAssistants": "View all my assistants and chatbots",
        "newPersona": "Create new character"
      },
      "categories": {
        "my": "My characters"
      },
      "personaForm": {
        "heading": "Set the chatbot's role",
        "create": "Create"
      }
    }
  }
}
